import React from 'react'
import ProdTaskBomRow from './ProdTaskBomRow'
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormTitle from '../../../../../library/form/components/FormTitle';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormLink from '../../../../../library/form/components/FormLink';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiRow, UiClear } from "../../../../../library/layout/Index";

const ProdTaskBom = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <>
            <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
                action={{ actionParam:{actionType: 'addBOMTask'},formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '350px' }}
                formStyle={{ width: '780px', height: '450px' }} formTitle={<FormTitle formObject={formObject} value="Order Details" />}
            >
            <UiView>
                <FormWrapper formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemBOMContainer" }}>
                    <UiRow>
                        <span className="uiLblS uiSpacerH5">
                            <FormLabel formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemId" }} value="Item ID" />:
                        </span>
                        <FormLink className="uiLink uiSpacerH15" formObject={formObject} headerKey="prodHeaderRow" linkProp={{ target: "_blank" }}
                            action={{ paramName: "itemId", actionId: "show", actionName: "itemComp" }}

                        />
                        <span className="uiLblS">
                            <FormLabel formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemName" }} value="Item Name" />:
                        </span>
                        <FormROValue formObject={formObject} headerKey="prodHeaderRow" action={{ paramName: "itemName" }} />
                    </UiRow>
                    <div className="uiSpacer10"></div>
                    <UiRow>
                        <span className="uiLblS uiSpacerH5">
                                <SarasTrans value = "Select BOM"/>:
                        </span>
                        <FormInput formObject={formObject} headerKey="prodHeaderRow"
                            action={{ InputType: "ac", paramName: "bomName", acMethod: "TargetItemBom", 
                            acDepCtrl: { 'dparam': '%dataList.valLDT', 'tdtId': '%dataList.tdtId',  'tdId': '%dataList.tdId'},
                            actionParam:{} }} className='uiInput uiSpacerH10' style={{width:'300px'}}/>
                        <FormButton formObject={formObject} headerKey="prodHeaderRow"
                            action={{ refreshMode:"self", actionId: "refresh",  actionParam: {actionType: 'prepareTaskFromBOM'}, }}
                            className="uiActionButton uiSpacerH10" text={<SarasTrans value="Generate BOM Tasks" />}></FormButton>
                    </UiRow>
                </FormWrapper>
                <div className="uiSpacer10"></div>
                <UiClear></UiClear>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value = "Process Plan"/></span>
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                            action={{ actionId: "new",  actionParam: {actionType : "addTask"}, containerKey: "row" }}
                            text={<SarasTrans value="Add Record" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Process" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Comment" /> </li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Est. Time" /> </li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Cost Formula" /> </li>
                                <li className="uiColumnCenter uiColumn60"><SarasTrans value="Action" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdTaskBomRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>            
        </FormDialog>
        </>
    )
}

export default withView(ProdTaskBom, "prodTaskBom", "prodTaskBom,prodTask,prodTaskList");